import React from 'react'

import { ArrowRight as ArrowRightIcon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import SubscriptionEntryPoints from 'Pods/Shared/Constants/subscriptionEntryPoints'
import i18n from 'Pods/Shared/I18n'
import { setSubscriptionEntry } from 'Pods/Shared/Utils/subscriptionEntry'

// Mirrors Subscription::DEFAULT_SUBSCRIPTION_PRICE formatted by Subscription.price_in_usd, which
// the server threads in as `subscriptionPrice`. Needed because fast pages serve HTML cached before
// that prop existed, so hydration can still hand us an undefined price.
export const DEFAULT_SUBSCRIPTION_PRICE = '$9.99'

function SubscribeBar({ price = DEFAULT_SUBSCRIPTION_PRICE, locale = 'en' }) {
  const translate = key => i18n.t(`subscribe_bar.${key}`, { ns: 'rails', lng: locale, price })

  // Written on click so a later conversion is credited here and not to whichever entry point
  // the visitor touched before.
  const handleClick = () => {
    setSubscriptionEntry(SubscriptionEntryPoints.LANDING_TOP_BANNER)
  }

  return (
    <a
      href="/subscription"
      className="timer-strip--top-bar"
      onClick={handleClick}
      data-subscription-entry={SubscriptionEntryPoints.LANDING_TOP_BANNER}
    >
      <div className="timer-strip timer-strip--subscription">
        <div className="timer-row timer-strip__subscription-row">
          <div className="timer-strip__item timer-strip__item--content timer-strip__item--content-no-timer">
            {/* Both keys hold the same copy today. The split stays so the next divergence is a
                translation-only edit rather than a markup one -- this strip's copy rotates often. */}
            <span className="timer-strip__content--full">
              {translate('content_full')}
            </span>
            <span className="timer-strip__content--short">
              {translate('content_short')}
            </span>
          </div>

          <div className="timer-strip__cta">
            {translate('cta')}
            <ArrowRightIcon width="16" height="16" />
          </div>
        </div>
      </div>
    </a>
  )
}

SubscribeBar.propTypes = {
  price: string,
  locale: string,
}

export default SubscribeBar
